import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
//import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postLogin,
  postJwtLogin,
  postSocialLogin,
//} from "../../../helpers/fakebackend_helper";
} from "helpers/accounts/accounts_backend_helper";

//const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    
   
      
    const response = yield call(postLogin, {
    
      //email: user.email,
      identifier: user.email,
      password: user.password,
    });


    let twoFactor = false;

    // Cas 2FA activé : l'API renvoie temp_token
    if (response.temp_token) {
      twoFactor = true;
      localStorage.setItem("tempToken", response.temp_token); // stockage temporaire
    } else {
      // Compte connecté normalement : on stocke l'access_token
      localStorage.setItem("authUser", JSON.stringify(response));
    }

    localStorage.setItem("twoFactor", JSON.stringify(twoFactor));

    // Redirection selon la présence de 2FA
    if (twoFactor) {
      history('/two-factor'); // page pour saisir le code 2FA
    } else {
      history('/dashboard');
    }
   
    //history('/dashboard');
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Une erreur est survenue";
    yield put(apiError(message));
  
 
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}



function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);

  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
